import kebabCase from "lodash-es/kebabCase";
import Link from "next/link";
import { useRouter } from "next/router";
import { accountSlug, billingSlug, paymentsSlug, ordersSlug } from "@utils/routes";
import { AccountType } from "@providers/profile/ProfileProvider.model";
import { SidebarLink, SidebarProps } from "./Sidebar.model";
import { Sidebar as StyledSidebar } from "../Account.styled";

const links = [
  { url: accountSlug, title: "My Account" },
  {
    url: billingSlug,
    title: "My Membership",
  },
  { url: paymentsSlug, title: "Payment History" },
  { url: ordersSlug, title: "Order History" },
];

// Child accounts can only see My Account page
const childLinks = links.slice(0, 1);

interface SidebarLinkProps {
  link_item: SidebarLink;
}

const SidebarLink = ({ link_item }: SidebarLinkProps) => {
  const { asPath } = useRouter();
  const isActive = asPath.replace(/\/$/, "") == link_item.url;

  return (
    <li data-testid={kebabCase(link_item.title)}>
      <Link className={`${isActive ? "active" : ""}`} href={link_item.url}>
        {link_item.title}
      </Link>
    </li>
  );
};

const Sidebar = ({ accountType }: SidebarProps) => {
  if (!accountType) return null;
  const isChildAccount = accountType === AccountType.CHILD;

  const renderLinks = () => {
    const renderedLinks = isChildAccount ? childLinks : links;

    return renderedLinks.map((link_item, idx) => <SidebarLink key={idx} link_item={link_item} />);
  };

  return (
    <StyledSidebar id="account-menu">
      <nav>
        <ul>{renderLinks()}</ul>
      </nav>
    </StyledSidebar>
  );
};

export default Sidebar;
